import { ApplicationEntity } from "@/model/entity/application-entity"
import { FieldDescriptor, FieldTypeEnum } from "@/model/entity//field-descriptor"
import { countryList } from "@/model/service/country/country-service"
import { Type } from "class-transformer"
import { Country } from "@/model/entity/country/country"

export class Address extends ApplicationEntity {
  office: any

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.address.name",
    isFilterable: true,
    isRequired: true
  })
  name: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.SELECT,
    fieldPrettyName: "entity.address.country",
    selectionFieldDescription: {
      displayKey: "i18nKey",
      valueKey: "isoCodeAlpha2",
      values: countryList,
      i18n: true
    },
    isFilterable: true,
    columnWidth: "100",
    isRequired: true
  })
  @Type(() => Country)
  country: Country

  @FieldDescriptor({
    fieldType: FieldTypeEnum.AUTOCOMPLETE,
    fieldPrettyName: "entity.address.zip_code",
    isFilterable: true,
    isRequired: true,
    autocompleteFieldApi: (country: string): string => {
      return "cities/fuzzy/zipcodes?country_code=" + country + "&zipcode="
    }
  })
  zipcode: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.AUTOCOMPLETE,
    fieldPrettyName: "entity.address.city",
    isFilterable: true,
    isRequired: true,
    autocompleteFieldApi: (country: string): string => {
      return "cities/fuzzy/cities?country_code=" + country + "&city="
    }
  })
  city: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.address.street",
    isFilterable: true,
    isRequired: true
  })
  street: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "entity.address.house_number",
    isFilterable: true
  })
  houseNumber: string

  street2: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.address.phone", isFilterable: true })
  phone: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.address.email", isFilterable: true })
  email: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.address.mobile", isFilterable: true })
  mobile: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.address.contact", isFilterable: true })
  contact: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.address.comment" })
  comment: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.address.fax", isFilterable: true })
  fax: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.address.own_code", isFilterable: true })
  ownCode: string

  @FieldDescriptor({ fieldType: FieldTypeEnum.BOOLEAN, fieldPrettyName: "entity.address.pickup", isFilterable: true })
  pickupActive: boolean

  constructor(
    office: any = null,
    country: any = null,
    name: string = "",
    zipcode: string = "",
    city: string = "",
    street: string = "",
    houseNumber: string = "",
    street2: string = "",
    phone: string = "",
    email: string = "",
    mobile: string = "",
    contact: string = "",
    comment: string = "",
    fax: string = "",
    ownCode: string = "",
    pickupActive: boolean = false,
    id?: number
  ) {
    super(id)
    this.office = office
    this.country = country
    this.name = name
    this.zipcode = zipcode
    this.city = city
    this.street = street
    this.houseNumber = houseNumber
    this.street2 = street2
    this.phone = phone
    this.email = email
    this.mobile = mobile
    this.contact = contact
    this.comment = comment
    this.fax = fax
    this.ownCode = ownCode
    this.pickupActive = pickupActive
  }
}
